import SpinStartState from "../../core/src/states/SpinStartState";
import BetModel from "../../core/src/model/BetModel";
import SpinModel from "../../core/src/model/SpinModel";
import UIController from "../../core/src/ui/UIController";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import App from "../../core/src/App";
import VendorModel from "../model/VendorModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ReelGroup from "../../core/src/views/ReelGroup";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import JackpotsModel from "../model/JackpotsModel";
import requestRegister from "../../../vendor_core/core/src/server/requests/RequestRegister"
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import BuyFeatureModel from "../../core/src/model/BuyFeatureModel";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import UIUtils from "../../core/src/utils/UIUtils";
import DebugModel from "../../core/src/model/DebugModel";

export default class VendorSpinStartState extends SpinStartState {

    protected monetaryPopup: boolean = false;

    startSpin() {
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.disableSwipeSpin();

        super.startSpin();
    }

    async sendRequest() {
        BetModel.betTime = Date.now();
        if (SpinModel.inFreegames() && SpinModel.isInFreespins()) {
            // We need to send ping request to the server in order to get the exact free games expire time.
            // Note it is in UTC time format, seconds elapsed since Jan 01 1970
            CommManager.send(requestRegister.get("pingRequest"), (data => {
                const localNow = new Date();
                const utcNowInSeconds = Math.round(Date.UTC(
                    localNow.getUTCFullYear(),
                    localNow.getUTCMonth(),
                    localNow.getUTCDate(),
                    localNow.getUTCHours(),
                    localNow.getUTCMinutes(),
                    localNow.getUTCSeconds(),
                    localNow.getUTCMilliseconds()
                ) / 1000);

                if (data?.freespins?.expires && data?.freespins?.expires < utcNowInSeconds) {
                    // 
                    VendorModel.hasFreeGamesExpiredDuringFreespins = true;
                    // Saving the settings.freegames.expiredDuringFreeSpins
                    // This will be used to display a popup on the next game start
                    // which will inform the user that all their winnings has been added to their balance.
                    // This happens only when the user refresh the page
                    // while in free spins, which are part of free games,
                    // but the free games are already expired and the free spins are still not finished.
                    CommandManager.execute(Commands.SAVE_SETTINGS);
                    this.onResponse();
                } else {
                    this.onResponse();
                }

            }), this);

            return;
        }

        if ((!SpinModel.isInFreespins() && !SpinModel.isInRespins())) {
            
           SpinModel.spinFinished = false;
           await  CommManager.send(
                requestRegister.get("spinRequest"),
                (data) => {
                    if(!SpinModel.inFreegames()) {
                        if(!BuyFeatureModel.hasBuyFeatureIsTriggered || this.hasExtraPermission()) {
                            this.makeBet();
                        }
                    }
                    this.onResponse(data)
                },
                this,
                (data) => {
                    ConsoleUtil.red("ERROR-REQ", data);

                    if (data.type && data.type == "error") {
                        ConsoleUtil.log("[RelaxComm] Error model:", data);
                        ErrorModel.update({
                            errorCode: 400,
                            errorMessage: "Connection error!",
                            critical: true,
                        });
                    } else {
                        ErrorModel.update(data);
                    }
                }
            )

            // update();
            
            // callback();
            // save balanse to store value after bet is subtracted.
            // we have to return correct value on refresh
            CommandManager.execute(Commands.SAVE_SETTINGS);
            this.exit();
        } else {
            this.onResponse();
        }
    }

    protected hasExtraPermission(): boolean {
        return false;
    }

    protected makeBet() {
        BetModel.subtractBet(BetModel.totalBet);
        UIController.updateFields(UIUpdateEvent.Balance);
    }

    protected onResponse(data?: any) {
        
        // In case the fake response cheat is used,
        // we need to change the server data with the fake one.
        if (data && DebugModel.fakeResponse) {
            if (data.request == DebugModel.fakeResponse.request) {
                // Modifying the data directly.
                // This way the inherited classes will get the fake one,
                // in case they first call super.onResponse(data);
                Object.assign(data, DebugModel.fakeResponse);
            }
        }
        
        // Make sure we will substitute the response only once.
        DebugModel.fakeResponse = null;
        
        if (!SpinModel.isInFreespins()) {
            // from RELAX-FEIM doc.
            // https://dev-cdn.relaxg.net/casino/docs/feim/interfaces/iroundstarteddata.html
            // "Just pass the play response if using Relax game server."
            // Copy the balance, then send it.
            const balanceToSend = BetModel.balance;
            CommandManager.execute(
                VendorCommandsEnum.GAME_ROUND_STARTED,
                {balance: balanceToSend, playResponse:data}
            )
        }

        SpinModel.update(data);
        ErrorModel.update(data);

        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.DECREMENT_AUTOPLAY);
        }
        
        if(data?.stats?.freespins?.spinsPlayed === 0) {
            CommandManager.execute(VendorCommandsEnum.SKIP_FREE_GAMES); 
        }
        VendorModel.update(data);
        !!data && RealityCheckModel.update(data.stats?.realityCheck);
        
        if (!SpinModel.isInFreespins()) {
            BetModel.update(data);
        } else {
            this.anounce();
        }

        //CommandManager.execute(Commands.UPDATE_BALANCE);
        if (data?.stats?.b) {
            BetModel.balance = data.stats.b;
        }
        this.exit();
    }

}
